import { useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { apiErrorMessage } from '../api/client'

export default function LoginPage() {
  const { user, login, register } = useAuth()
  const navigate = useNavigate()
  const location = useLocation() as { state?: { from?: { pathname?: string } } }

  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [inviteToken, setInviteToken] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  if (user) {
    return <Navigate to={location.state?.from?.pathname || '/'} replace />
  }

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      if (mode === 'login') await login(email, password)
      else await register(email, password, inviteToken)
      navigate(location.state?.from?.pathname || '/', { replace: true })
    } catch (err) {
      setError(apiErrorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'grid',
        placeItems: 'center',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" sx={{ mb: 0.5 }}>
            Immo Gérer
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            {mode === 'login'
              ? 'Connectez-vous pour accéder à vos simulations.'
              : 'Créez un compte.'}
          </Typography>

          <form onSubmit={submit}>
            <Stack spacing={2}>
              {error && <Alert severity="error">{error}</Alert>}
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <TextField
                label="Mot de passe"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                helperText={mode === 'register' ? '8 caractères minimum' : ' '}
              />
              {mode === 'register' && (
                <TextField
                  label="Jeton d'invitation"
                  value={inviteToken}
                  onChange={(e) => setInviteToken(e.target.value)}
                  required
                  helperText="Fourni par un administrateur"
                />
              )}
              <Button type="submit" variant="contained" size="large" disabled={busy}>
                {mode === 'login' ? 'Se connecter' : 'Créer le compte'}
              </Button>
            </Stack>
          </form>

          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            {mode === 'login' ? 'Pas encore de compte ? ' : 'Déjà inscrit ? '}
            <Link
              component="button"
              type="button"
              onClick={() => {
                setMode(mode === 'login' ? 'register' : 'login')
                setError('')
              }}
            >
              {mode === 'login' ? 'Créer un compte' : 'Se connecter'}
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
